import { createContext } from 'react'

import type { HistoryContextData } from '@tivio/types'


export const CustomAppHistoryContext = createContext<HistoryContextData | undefined>(undefined)
